import { ref, onMounted, onUnmounted } from 'vue'

/**
 * Reactive flag for whether the user's primary pointer supports hover.
 * Backed by `window.matchMedia('(hover: hover)')`, which is the only reliable
 * way to distinguish a mouse from a touch screen — viewport width is not
 * enough (e.g., iPad Pro 12.9 in landscape is 1366px wide but has no hover).
 *
 * SSR-safe: defaults to `true` until mounted, then reads the actual MQ value.
 * Updates if the user docks/undocks a trackpad (the MQ fires `change`).
 *
 * @returns {{ hasHover: import('vue').Ref<boolean> }}
 */
export function useHasHover() {
  const hasHover = ref(true)
  let mql = null
  const update = () => { hasHover.value = mql.matches }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    mql = window.matchMedia('(hover: hover)')
    hasHover.value = mql.matches
    mql.addEventListener('change', update)
  })

  onUnmounted(() => {
    if (mql) mql.removeEventListener('change', update)
  })

  return { hasHover }
}
